




















































import type { PropType } from "vue"
import type { stadium_info } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import moment from "moment"
import AreaPicker from '@/components/areapicker.vue'

export default Vue.extend({
  name: "StadiumInfoForm",
  components: { AreaPicker },
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_info> },
  },
  data() {
    return {
      area: [] as string[],
      time: null as moment.Moment | null,
      rules: {
        name              : { required: true, message: "场馆名称不能为空", trigger: "blur" },
        province_id       : { required: true, message: "场馆地区不能为空", trigger: "blur" },
        addr              : { required: true, message: "详细地址不能为空", trigger: "blur" },
        open_time         : { required: true, message: "场馆开业时间不能为空", trigger: "blur" },
        rent_run_years    : { required: true, message: "场馆已经营年限不能为空", trigger: "blur" },
        rent_surplus_years: { required: true, message: "场馆租赁剩余年限不能为空", trigger: "blur" },
        rent_type         : { required: true, message: "场馆租赁续签情况不能为空", trigger: "blur" },
        stadium_size      : { required: true, message: "场馆总面积不能为空", trigger: "blur" },
        ground_count      : { required: true, message: "羽毛球片场数不能为空", trigger: "blur" },
      },
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.area = [String(this.form.province_id.padEnd(6, "0")), String(this.form.city_id.padEnd(6, "0")), String(this.form.county_id)]
        this.time = moment(this.form.open_time, "YYYY-MM-DD")
      })
    },
    choose_area(value: string[]) {
      this.form.province_id = value[0] as string
      this.form.city_id     = value[1] as string
      this.form.county_id   = value[2] as string
    },
    /* 修改续约状态 */
    change_rent_type(type: string) {
      this.form.rent_type = type
    },
    submit() {
      if (this.time) this.form.open_time = this.time.format("YYYY-MM-DD")
      const form = this.$refs.form as any
      const params = this.$deep_copy(this.form)
      params.estimate_id = this.id
      form.validate((valid: boolean) => {
        if (valid) this.$emit("save", params)
      })
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  }
})
